<template>
  <div class="data-list-container">
    <vs-table ref="table" max-items="10" :data="trainings">
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <div
            @click="loadPackTranings(page)"
            class="
              btn-add-new
              p-3
              mb-4
              mt-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-center
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
          >
            <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Actualiser</span>
          </div>
          <div
            v-if="isAdmin()"
            @click="$router.push({ name: 'formation-add-pack' })"
            class="
              btn-add-new
              p-3
              mb-4
              mt-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-center
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary"
              >Ajouter un pack de formations</span
            >
          </div>
        </div>
        <div class="con-input-search vs-table--search">
          <input
            v-model="search"
            @keypress.enter="searchInfo()"
            type="text"
            class="input-search vs-table--search-input"
          />
          <i class="vs-icon notranslate icon-scale material-icons null"
            >search</i
          >
        </div>
      </div>

      <template slot="thead">
        <vs-th>Titre</vs-th>
        <vs-th>Type évaluation</vs-th>
        <vs-th>Auteur</vs-th>
        <vs-th>Date de création</vs-th>
        <vs-th>Actions</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.title | truncate(50) }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.type_evaluation }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.author }}</p>
            </vs-td>

            <vs-td>
              <p class="product-price">
                {{ tr.created_at }}
              </p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <div class="flex">
                <vx-tooltip text="Modifier le pack" v-if="isAdmin()">
                  <feather-icon
                    @click="
                      $router.push({
                        path: '/formation/update-pack/' + tr.slug,
                      })
                    "
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>
                <vx-tooltip text="Fréquentation par agent" v-if="isAdmin()">
                  <feather-icon
                    @click="
                      $router.push({
                        path: '/formation/packs/users-tracking/' + tr.slug,
                      })
                    "
                    icon="BarChartIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>
                <vx-tooltip text="Supprimer le pack" v-if="isAdmin()">
                  <feather-icon
                    @click="deleteData(tr)"
                    icon="XIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    &nbsp;&nbsp;&nbsp;
    <vs-row>
      <vs-col
        vs-offset="5"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="1"
      >
        <vs-pagination
          v-if="last_page && page"
          :total="last_page"
          v-model="page"
        ></vs-pagination>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { _buildQuery } from "../../../helpers/buildquery";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import vSelect from "vue-select";

export default {
  name: "ListePacksAdmin",
  components: {
    Datepicker,
    vSelect,
  },
  data() {
    return {
      param: new FormData(),
      loading: false,
      trainings: [],
      itemsPerPage: 4,
      isMounted: false,
      published: false,
      params: {
        page: 1,
        type: "",
        category: "",
        limit: 18,
      },
      search: "",
      medias: [],
      url: "/trainings",
      formErrors: {},
      page: 1,
      last_page: null,
    };
  },
  watch: {
    page(value) {
      this.loadPackTranings(value);
    },
  },
  computed: {
    parseDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  methods: {
    isAdmin() {
      return this.$store.state.AppActiveUser.roles[0].name === "admin"
        ? true
        : false;
    },
    async deleteData(tr) {
      if (confirm("Voulez-vous vraiment supprimer ce pack ?")) {
        try {
          this.loading = true;
          this.$vs.loading();
          let response = await this.$http.post("trainings-pack/delete", {
            pack_slug: tr.slug,
          });
          if (response.data) {
            this.loading = false;
            this.$vs.loading.close();
            window.getApp.success("Le pack a été supprimée avec succès.");
            let index = this.trainings.indexOf(tr);
            this.trainings.splice(index, 1);
          }
        } catch (error) {
          this.loading = false;
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erreur",
            text: error.response.data.message
              ? error.response.data.message
              : "Veuillez contacter l'administrateur",
            color: "danger",
            position: "top-right",
          });
        }
      }
    },
    async loadPackTranings(page) {
      if (this.checkIfuserHasRole("agent")) {
        this.$router.push({ path: "trainings-pack/index" });
      } else {
        try {
          this.params.page = page;

          this.loading = true;
          this.$vs.loading();
          let response = await this.$http.get(
            "trainings-pack/index" + _buildQuery(this.params)
          );
          if (response.data) {
            this.loading = false;
            this.$vs.loading.close();
            this.trainings = response.data.data;
            this.last_page = response.data.last_page;
          }
        } catch (error) {
          this.loading = false;
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erreur",
            text: error.response.data.message
              ? error.response.data.message
              : "Veuillez contacter l'administrateur",
            color: "danger",
            position: "top-right",
          });
        }
      }
    },
    async searchInfo() {
      if (this.search != "") {
        try {
          this.$vs.loading();
          let response = await this.$http.get(
            "trainings-pack/index" + _buildQuery({ search: this.search })
          );
          if (response.data) {
            this.$vs.loading.close();
            this.trainings = response.data.data;
            this.search = "";
            this.last_page = null;
          }
        } catch (error) {
          this.$vs.loading.close();
          console.log("error " + JSON.stringify(error));
        }
      }
    },
  },
  created() {
    this.loadPackTranings(this.page);
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
@import "vue-select/src/scss/vue-select.scss";
</style>

